import { apiWithoutBaseURL } from './api'

class GraphService {
    // 批量添加节点和关系
    async addByBatch(data) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addByBatch/', data)
            return response.data
        } catch (error) {
            console.error('批量添加失败:', error)
            throw error
        }
    }

    // 修改图谱关系
    async changeGraph(data) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/changeGraph/', data)
            return response.data
        } catch (error) {
            console.error('修改图谱关系失败:', error)
            throw error
        }
    }

    // 翻译单词
    async translateWord(word) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/translateWord/', { word })
            return response.data
        } catch (error) {
            console.error('翻译单词失败:', error)
            throw error
        }
    }

    // 为节点添加标签
    async addTagToNode(nodeId, tagName) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addTagToNode/', {
                node_id: nodeId,
                tag_name: tagName
            })
            return response.data
        } catch (error) {
            console.error('为节点添加标签失败:', error)
            throw error
        }
    }

    // 检查节点是否存在
    async checkNode(nodeName) {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/checkNode/', {
                params: { node_name: nodeName }
            })
            return response.data
        } catch (error) {
            console.error('检查节点失败:', error)
            throw error
        }
    }

    // 查找所有标签
    async findTags() {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findTags/')
            return response.data
        } catch (error) {
            console.error('查找标签失败:', error)
            throw error
        }
    }

    // 查找所有标签
    async findAllTags() {
        try {
            const response = await apiWithoutBaseURL.get('/Graph/api/findAllTags/')
            return response.data
        } catch (error) {
            console.error('查找所有标签失败:', error)
            throw error
        }
    }

    // 根据节点查找图谱关系
    async findGraphByNode(nodeName, times = 0) {
        try {
            let url = `/Graph/api/findGraphByNode/${nodeName}/`
            if (times > 0) {
                url = `/Graph/api/findGraphByNode/${nodeName}/${times}/`
            }
            const response = await apiWithoutBaseURL.get(url)
            return response.data
        } catch (error) {
            console.error('根据节点查找图谱关系失败:', error)
            throw error
        }
    }

    // 查找节点
    async findNode(nodeName) {
        try {
            const response = await apiWithoutBaseURL.get(`/Graph/api/findNode/${nodeName}/`)
            return response.data
        } catch (error) {
            console.error('查找节点失败:', error)
            throw error
        }
    }

    // 修改节点
    async modifyNode(nodeId, nodeName, nodeDesc) {
        try {
            // 使用POST请求传递参数，避免URL中特殊字符导致的问题
            const response = await apiWithoutBaseURL.post('/Graph/api/modifyNode/', {
                nodeId: nodeId,
                nodeName: nodeName,
                nodeDesc: nodeDesc
            })
            return response.data
        } catch (error) {
            console.error('修改节点失败:', error)
            throw error
        }
    }

    // 删除节点
    async deleteNode(nodeId) {
        try {
            const response = await apiWithoutBaseURL.get(`/Graph/api/deleteNode/${nodeId}/`)
            return response.data
        } catch (error) {
            console.error('删除节点失败:', error)
            throw error
        }
    }

    // 添加节点
    async addNode(nodeName, nodeDesc = null) {
        try {
            // 使用POST请求传递参数，避免URL中特殊字符导致的问题
            const response = await apiWithoutBaseURL.post('/Graph/api/addNode/', {
                nodeName: nodeName,
                nodeDesc: nodeDesc
            })
            return response.data
        } catch (error) {
            console.error('添加节点失败:', error)
            throw error
        }
    }

    // 添加子节点
    async addChildNode(nodeId, nodeName, graphId, nodeDesc = null) {
        try {
            // 使用POST请求传递参数，避免URL中特殊字符导致的问题
            const response = await apiWithoutBaseURL.post('/Graph/api/addChildNode/', {
                nodeId: nodeId,
                nodeName: nodeName,
                graphId: graphId,
                nodeDesc: nodeDesc
            })
            return response.data
        } catch (error) {
            console.error('添加子节点失败:', error)
            throw error
        }
    }

    // 添加关系
    async addGraph(sourceId, targetId, graphId) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addGraph/', {
                source: sourceId,
                target: targetId,
                graphId: graphId
            })
            return response.data
        } catch (error) {
            console.error('添加关系失败:', error)
            throw error
        }
    }

    // 删除关系
    async deleteGraph(sourceId, targetId, graphId) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/deleteGraph/', {
                source: sourceId,
                target: targetId,
                graphId: graphId
            })
            return response.data
        } catch (error) {
            console.error('删除关系失败:', error)
            throw error
        }
    }

    // 添加标签
    async addTag(tagName) {
        try {
            const response = await apiWithoutBaseURL.post('/Graph/api/addTag/', {
                tagName: tagName
            })
            return response.data
        } catch (error) {
            console.error('添加标签失败:', error)
            throw error
        }
    }

    // 模糊查找节点
    async fuzzyFindNode(nodeName) {
        try {
            const response = await apiWithoutBaseURL.get(`/Graph/api/fuzzyFindNode/${nodeName}/`)
            return response.data
        } catch (error) {
            console.error('模糊查找节点失败:', error)
            throw error
        }
    }
}

export default new GraphService()